// Module
var code = "<div class=\"col-sm-4 text-center\"> <h4 translate ng-if=\"view !== 'member_edit'\">{{'app.shared.wallet.your_wallet_amount'}}</h4> <h4 translate ng-if=\"view === 'member_edit'\">{{'app.shared.wallet.wallet_amount'}}</h4> <div class=\"wallet-amount-container\"> <div class=\"wallet-amount\">{{wallet.amount | currency}}</div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/wallet/show.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;